import {assertAndContinue} from 'Asserts';
import deepCopy from 'lib/deepCopy';
import {OpenCreateModalArgs} from 'requests/dashboard/openCreateRequestModal';
import {getInitialTags} from 'schemas/tags/TagUtil';
import EntityStore from 'stores/EntityStore';

import {RequestTemplateGraphQL} from '../../../graphql-fragments/requests/__generated/RequestTemplateGraphQL';
import {RequestTaskSchemaGraphQL} from '../../../graphql-fragments/requests/schemas/__generated/RequestTaskSchemaGraphQL';
import {RequestAssignee, RequestSchema} from '../RequestConstants';
import {makeRequestTaskFromTemplate} from '../tasks/MakeRequestTask';
import {mergeTemplateTags} from './RequestTemplateUtil';

function getRequestTemplate(
  schema: RequestSchema,
  requestTemplatesById: Record<string, RequestTemplateGraphQL>
): RequestTemplateGraphQL | null {
  if (schema.requestTemplateIds.length > 0) {
    assertAndContinue(
      schema.requestTemplateIds.length === 1,
      'Did not expect multiple templates for a single schema. Continuing with first template'
    );
    return requestTemplatesById[schema.requestTemplateIds[0]];
  }
  return null;
}

function cloneAssignees(assignees: Array<RequestAssignee>): Array<RequestAssignee> {
  return deepCopy(assignees);
}

export default function getInitialRequestProps(
  schema: RequestSchema,
  requestTemplatesById: Record<string, RequestTemplateGraphQL>,
  requestTaskSchemasById: Record<string, RequestTaskSchemaGraphQL>
): OpenCreateModalArgs {
  const emptyTags = getInitialTags(schema.fields);
  const template = getRequestTemplate(schema, requestTemplatesById);
  const initialRequestor = EntityStore.currentUser();
  const initialAssignees = template ? cloneAssignees(template.assigneesJson) : [];
  const initialProjectId = template ? template.defaultProject?.id : null;
  const initialTags = template ? mergeTemplateTags(emptyTags, template.tagsJson) : emptyTags;
  const taskTemplates = template ? template.taskTemplates : [];
  const initialRequestTasks = taskTemplates
    .filter((taskTemplate) => taskTemplate.autoAdd)
    .map((taskTemplate) =>
      makeRequestTaskFromTemplate(requestTaskSchemasById[taskTemplate.schema.id], taskTemplate)
    );

  return {
    schema,
    initialTags,
    initialRequestor,
    initialAssignees,
    initialRequestTasks,
    initialProjectId,
    template,
  };
}
